<div fxLayout="column" class="wrapper height-100">
  <div>
    <mat-toolbar fxFlex fxLayout="row">
      <div
        fxLayout="column"
        fxLayout.gt-sm="row"
        fxLayoutAlign="start center"
        [class.compact-header-text]="media.isActive('lt-sm')"
      >
        <span class="mat-body-1 padding-right-2">
          {{ 'LABEL_RECORD_COUNT' | translate }}
        </span>
        <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center">
          <span class="mat-body-1">
            {{ listLength | formatNumber }}
          </span>

          <mat-icon
            *ngIf="moduleCode === 'PTXNR' || moduleCode === 'STLMR' || moduleCode === 'PATR'"
            matTooltip="{{ 'MSG_REPORTS_DISPLAY_LIMIT' | translate }}"
            class="large-icon"
            matSuffix
            color="primary"
          >
            help_outline
          </mat-icon>
        </div>
      </div>

      <div fxFlex fxLayout fxLayoutAlign="end center">
        <button
          id="id_refresh_btn"
          mat-icon-button
          [matTooltip]="'LABEL_REFRESH' | translate"
          [disabled]="isAnyLoading()"
          (click)="refresh()"
        >
          <mat-icon svgIcon="refresh"></mat-icon>
        </button>
        <button
          id="id_filter_btn"
          mat-icon-button
          [matTooltip]="'LABEL_DOWNLOAD_REPORT' | translate"
          [disabled]="isAnyLoading() || !listLength"
          (click)="downloadRequested()"
        >
          <mat-icon svgIcon="download"></mat-icon>
        </button>
        <button
          id="id_filter_btn"
          [class.filter-color]="filterNumber > 0"
          mat-icon-button
          [matTooltip]="'LABEL_FILTER' | translate"
          [disabled]="isAnyLoading()"
          (click)="openFilter()"
        >
          <mat-icon svgIcon="filter-variant"></mat-icon>
        </button>
      </div>
    </mat-toolbar>
  </div>

  <div
    fxLayout="column"
    class="report-table-wrapper"
    *ngIf="listLength && !loading.error"
    [class.empty-report]="!listLength"
    fxFlex
  >
    <div *ngIf="!loading.list && listLength">
      <table
        mat-table
        [dataSource]="
          listData
            | paginate
              : {
                  id: 'server',
                  itemsPerPage: pageSize,
                  currentPage: page,
                  totalItems: listLength
                }
        "
      >
        <ng-container
          *ngFor="let column of columns"
          [matColumnDef]="column.def"
        >
          <th mat-header-cell *matHeaderCellDef>{{ column.header }}</th>
          <td mat-cell *matCellDef="let element">
            {{ element[column.def] }}
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <!-- The subtotal-row is used exclusively for grouping the detailed settlement report. -->
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [ngClass]="{
            'subtotal-row': row.campaign_description === 'Subtotal'
          }"
        ></tr>
      </table>
    </div>
  </div>
  <esc-paginator
    *ngIf="listLength && !loading.error"
    [length]="listLength"
    [pageSize]="pageSize"
    [page]="page"
    [pageSizeOptions]="pageSizeOptions"
    (onPageChange)="changePage($event)"
    id="server"
  >
  </esc-paginator>

  <div
    *ngIf="!isAnyLoading() && !listData.length && !loading.error"
    fxFlex
    fxLayout="column"
    fxLayoutAlign="center center"
  >
    <mat-icon
      color="primary"
      svgIcon="information-outline"
      class="size-48"
    ></mat-icon>
    <span
      class="mat-body"
      [class.compact-header-text]="media.isActive('lt-sm')"
    >
      {{ 'LABEL_NO_DATA' | translate }}
    </span>
  </div>

  <div
    *ngIf="loading.error && !isAnyLoading()"
    fxLayoutGap="20px"
    fxFlex
    fxLayout="column"
    fxLayoutAlign="center center"
  >
    <mat-icon
      color="warn"
      svgIcon="alert-circle-outline"
      class="size-48"
    ></mat-icon>
    <span class="mat-body">
      {{ 'MSG_ERROR_NETWORK_CONNECTION' | translate }}
    </span>
    <button color="primary" mat-raised-button (click)="refresh()">
      {{ 'LABEL_RETRY' | translate }}
    </button>
  </div>

  <div
    *ngIf="isAnyLoading()"
    fxFlex
    fxLayout="column"
    fxLayoutAlign="center center"
    class="loading-indicator-report"
    style="z-index: 200; top: 0"
  >
    <mat-spinner></mat-spinner>
  </div>
</div>
